import { create } from 'zustand';
import { ChatMessage } from '../lib/chatService';

interface ChatStore {
    // Pending messages that should be added to chat when it opens
    pendingMessages: Map<string, ChatMessage[]>; // projectId -> messages[]

    // Version counter - increments when messages are added to trigger re-renders
    version: number;

    // Add a pending message for a project
    addPendingMessage: (projectId: string, message: ChatMessage) => void;

    // Get and clear pending messages for a project
    getPendingMessages: (projectId: string) => ChatMessage[];

    // Clear pending messages for a project
    clearPendingMessages: (projectId: string) => void;
}

export const useChatStore = create<ChatStore>((set, get) => ({
    pendingMessages: new Map(),
    version: 0,

    addPendingMessage: (projectId: string, message: ChatMessage) => {
        set((state) => {
            const newMap = new Map(state.pendingMessages);
            const existing = newMap.get(projectId) || [];
            newMap.set(projectId, [...existing, message]);
            console.log('📬 ChatStore: Added pending message for project', projectId, message.id);
            return { pendingMessages: newMap, version: state.version + 1 };
        });
    },

    getPendingMessages: (projectId: string) => {
        const messages = get().pendingMessages.get(projectId) || [];
        if (messages.length > 0) {
            console.log('📭 ChatStore: Retrieved', messages.length, 'pending messages for project', projectId);
        }
        return messages;
    },

    clearPendingMessages: (projectId: string) => {
        set((state) => {
            const newMap = new Map(state.pendingMessages);
            newMap.delete(projectId);
            console.log('🗑️ ChatStore: Cleared pending messages for project', projectId);
            return { pendingMessages: newMap };
        });
    }
}));
